import moment from 'moment'

export default {
  filters: {
    toYesNoString: function (value) {
      if (typeof value === 'string') {
        value = parseInt(value)
      }
      return value ? 'Yes' : 'No'
    },
    toTestStatusString: function (value) {
      switch (value) {
        case 0:
          return 'OK'
        case 1:
          return 'Cancelled'
        default:
          return 'Unknown'
      }
    },
    formatDate: function (value) {
      if (value) {
        const format = 'MMM DD, YYYY, HH:mm'
        return value instanceof Date ? moment(value.toISOString()).utc().format(format) : moment(value).utc().format(format)
      } else {
        return '-'
      }
    },
    formatNumber: function (value) {
      if (value) {
        return value.toLocaleString('en')
      } else {
        return '-'
      }
    }
  },
  create: function (Vue) {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js